import React from "react";
import "./GMBScoring.css";
import useLang from "../../i18n/useLang";
import { demoUrl } from "../../i18n/links";
import content from "./content";

const LockOverview = ({ isIssue, issuesRemaning }) => {
  const lang = useLang();
  const t = content[lang].lock;
  return (
    <div className="lock-overview-container">
      <button
        onClick={() => {
          window.open(demoUrl(lang, "audit-google-my-business"), "_blank");
        }}
        className="locked-btn"
      >
        {t.cta}
      </button>
      {isIssue && issuesRemaning > 0 && (
        <p style={{ textAlign: "center", fontSize: 13, color: "var(--color-text-muted)", marginTop: 8 }}>
          {t.remaining(issuesRemaning)}
        </p>
      )}
    </div>
  );
};

export default LockOverview;
